<!-- 咨询页面 -->
<template>
  <div class="consult">
    <div class="left">
      <OssImg class="consultImg" src="/UIV3/consult.png" alt="" />
    </div>
    <div class="right">
      <div v-if="isNotSubmit" class="notSubmit">
        <div class="title" style="text-align: center">
          <div class="text1" style="margin-bottom: 0.5rem">方案咨询</div>
          <div class="desc">即刻开启实验室方案咨询，建立实验室安全生态</div>
        </div>
        <div class="formBox">
          <el-form ref="ruleFormRef" :rules="rules" :model="formData" label-width="10rem">
            <el-form-item label="姓名" prop="contact">
              <el-input v-model="formData.contact" placeholder="请输入联系人姓名" maxlength="10" />
            </el-form-item>
            <el-form-item label="联系电话" prop="contactPhone">
              <el-input v-model="formData.contactPhone" placeholder="请输入联系电话" maxlength="11" />
            </el-form-item>
            <el-form-item label="学校/公司名称" prop="deptName">
              <el-input v-model="formData.deptName" placeholder="请输入学校/公司名称" maxlength="20" />
            </el-form-item>
            <el-form-item label="咨询问题(可选)" prop="askQuestions">
              <el-input
                v-model="formData.askQuestions"
                type="textarea"
                :rows="4"
                maxlength="500"
                show-word-limit
                placeholder="将您的需求和疑问反馈给我们"
              />
            </el-form-item>
          </el-form>

          <el-button
            :loading="isSubmitting"
            :disabled="isSubmitting"
            @click="submitForm(ruleFormRef)"
            style="
              background-color: #32a89e;
              height: 40px;
              color: #fff;
              width: 100%;
            "
          >提交</el-button>
        </div>
        <div class="bottomTip">
          表单提交后，会有工作人员与您电话联系,如果您现在就需要帮助，可立即拨打
          <span style="color: #32a89e">400-966-5960</span>
          与我们联系！
        </div>
      </div>
      <div v-else class="submit">
        <div style="display: flex; justify-content: center">
          <OssImg src="/UIV3/submitSuccess.png" alt="" />
        </div>
        <div class="successTip">提交成功</div>
        <el-button @click="navTo('/home')" style="
            background-color: #32a89e;
            height: 40px;
            color: #fff;
            width: 100%;
          ">回到首页</el-button>
        <div class="bottomTip">
          如果您现在就需要帮助，可立即拨打
          <span style="color: #32a89e">400-966-5960</span>
          与我们联系！
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from "vue";
import { ElMessage } from "element-plus";
import { phoneReg, CEReg } from "@/utils/reg";
import { navTo } from "@/utils/util";
import ConsultApi from "@/api/consultApi.js";
import { containsSqlInjectionProbe } from "@/utils/consultSecurity";
const ruleFormRef = ref(null);
const formData = ref({
  contact: "",
  contactPhone: "",
  deptName: "",
  askQuestions: "",
});
const isSubmitting = ref(false);
let isNotSubmit = ref(true);
const createCustomValidator = (regex, errorMessage) => {
  return (rule, value, callback) => {
    if (!value) {
      callback(new Error("该字段不能为空"));
    } else if (!regex.test(value)) {
      callback(new Error(errorMessage));
    } else {
      callback();
    }
  };
};
const sqlProbeValidator = (rule, value, callback) => {
  if (value && containsSqlInjectionProbe(value)) {
    callback(new Error("内容包含非法 SQL 探测"));
  } else {
    callback();
  }
};
const rules = reactive({
  contact: [
    { required: true, message: "请输入姓名", trigger: "blur" },
    {
      validator: createCustomValidator(CEReg, "请输入正确姓名"),
      trigger: "blur",
    },
    { validator: sqlProbeValidator, trigger: "blur" },
  ],
  contactPhone: [
    { required: true, message: "请输入联系电话", trigger: "blur" },
    {
      validator: createCustomValidator(phoneReg, "请输入正确手机号"),
      trigger: "blur",
    },
    { validator: sqlProbeValidator, trigger: "blur" },
  ],
  deptName: [
    { required: true, message: "请输入学校/公司名称", trigger: "blur" },
    {
      validator: createCustomValidator(CEReg, "请输入正确学校/公司名称"),
      trigger: "blur",
    },
    { validator: sqlProbeValidator, trigger: "blur" },
  ],
  askQuestions: [
    { max: 500, message: "咨询问题不能超过500个字符", trigger: "blur" },
    { validator: sqlProbeValidator, trigger: "blur" },
  ],
});

/**
 * 提交表单
 */
const submitForm = async (formEl) => {
  if (!formEl || isSubmitting.value) return;

  isSubmitting.value = true;
  try {
    const valid = await formEl.validate().catch(() => false);
    if (!valid) return;

    // 只提交官网表单允许的字段，避免把内部字段带入公开接口。
    await ConsultApi.saveConsult({
      contact: formData.value.contact.trim(),
      contactPhone: formData.value.contactPhone.trim(),
      deptName: formData.value.deptName.trim(),
      askQuestions: formData.value.askQuestions.trim(),
    });
    isNotSubmit.value = false;
    ElMessage.success("提交成功");
  } catch (error) {
    const message =
      error?.response?.data?.msg ||
      error?.message ||
      "提交失败，请稍后再试";
    ElMessage.error(message);
  } finally {
    isSubmitting.value = false;
  }
};
</script>

<style lang="scss" scoped>
.consult {
  display: flex;
  align-items: center;
  gap: 24px;

  .left {
    flex: 1;

    .consultImg {
      width: 100%;
      height: 100%;
    }
  }

  .right {
    width: 40%;
  }
}

.desc {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 1.5rem;
  color: #424242;
  padding: 0rem 20px;
  margin-bottom: 1.5rem;
  word-break: break-all;
}

:deep(.el-input) {
  width: 110%;
}

:deep(.el-form-item__label) {
  font-family: PingFang SC, PingFang SC;
  font-weight: 700;
  font-size: 1rem;
  color: #424242;
}

.notSubmit {
  .formBox {
    // width: 48.625rem;
    width: 90%;
    margin: auto;
  }
}

.submit {
  margin-left: 2rem;
  width: 70%;
  text-align: center;

  .successTip {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: #424242;
    margin: 24px 0px;
  }
}

.bottomTip {
  width: 100%;
  color: #424242;
  font-family: "PingFang SC";
  font-weight: 700;
  font-size: 0.75rem;
  text-align: center;
  margin-top: 15vh;
}
</style>
